import { Navigate, useRoutes } from 'react-router-dom';
//
import { useAuthContext } from 'src/auth/hooks';
import { USER_TYPE } from 'src/types/ApiConstant';
import { paths } from '../paths';
import { authRoutes } from './auth';
import { guestRoutes } from './guest';
import { homeRoutes } from './home';
import { mainRoutes } from './main';

// ----------------------------------------------------------------------

export default function Router() {
  const { user } = useAuthContext();
  return useRoutes([
    {
      path: '/',
      element: (
        <Navigate
          to={
            user?.type === USER_TYPE.READER ? paths.danh_cho_ban_doc.tra_cuu : paths.home.trang_chu
          }
          replace
        />
      ),
    },

    // Guest routes
    ...guestRoutes,

    // Auth routes
    ...authRoutes,

    // home routes
    ...homeRoutes,

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
